import { ErrorOutline, Refresh } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

interface TableErrorProps {
  message?: string;
  onRetry?: () => void;
}

export function TableError({
  message = 'Something went wrong while loading data.',
  onRetry,
}: TableErrorProps) {
  return (
    <Box
      sx={{
        py: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'background.paper',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <ErrorOutline sx={{ fontSize: 48, color: 'error.main', opacity: 0.8 }} />
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Unable to load data
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
      {onRetry && (
        <Button variant="outlined" startIcon={<Refresh />} onClick={onRetry} sx={{ mt: 1 }}>
          Try Again
        </Button>
      )}
    </Box>
  );
}
